// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__LtxZd","loader":"Loader_loader__ChRMX","spin":"Loader_spin__Soegw","small":"Loader_small__+eZhf","mt8":"Loader_mt8__K+uov"};